/**
* @version GENERATOR_VERSION::20200422
* @DateTime 2020-05-01T18:10:47.027
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listOrgPosition,
	listOrgPositionInit,
	listOrgPositionByAuthorizations,
	deleteOrgPosition
} from '@api/systemmanage/OrgPosition';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listOrgPosition({
			state
		}) {
			return new Promise((resolve, reject) => {
				listOrgPosition(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listOrgPositionByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listOrgPositionByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listOrgPositionInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listOrgPositionInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteOrgPosition({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteOrgPosition({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
